import styled, { css } from "styled-components";
import { type SpaceProps, space } from "styled-system";
import { getBreakpoint } from "../../../../../../../../common-deprecated/themes/common";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/lexus/theme/lexusTheme";
import Icon from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/Icon";
import { IconWrapper } from "../../../../../../../../common-deprecated/styles/v2/lexus/globals/IconWrapper";

export const FilterToggle = styled.span`
    display: flex;
    position: relative;
    align-items: center;
    padding: 12px 0 24px;
    border-bottom: 1px solid ${theme.colors.silver};
    cursor: pointer;
    user-select: none;
`;

export const FilterBadge = styled.span<{ selected: boolean }>`
    display: flex;
    position: absolute;
    top: 6px;
    left: 12px;
    align-items: center;
    justify-content: center;
    width: 14px;
    height: 14px;
    font-size: 0.8rem;
    line-height: 1;
    text-align: center;
    border-radius: 50%;
    box-shadow: 0 0 1px 1px rgba(255, 255, 255, 0.6);
    ${({ selected }) => css`
        color: ${theme.colors.midnight};
        background: ${theme.colors.white};
        border: 2px solid ${theme.colors.silver};
        ${selected &&
        css`
            border: 2px solid ${theme.colors.midnight};
        `};
    `};

    html[dir="rtl"] & {
        left: auto;
        right: 12px;
    }
`;

export const FilterPopover = styled.div`
    position: absolute;
    top: 42px;
    left: 0;
    right: 0;
    min-width: 335px;
    padding: 20px 30px;
    background-color: ${theme.colors.white};
    border-radius: 0;
    box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.25);
    z-index: 2055;
    /* className="or-extras-filter-overlay or-popover or-popover-without-point" */
`;

export const FilterPopoverLine = styled.div`
    display: flex;
    flex: 1;
    flex-direction: row;
    justify-content: space-between;
    padding: 10px 0;
    border-bottom: 1px solid ${theme.colors.silver};
    cursor: pointer;
    user-select: none;
`;

export const FilterPopoverTitle = styled.div<SpaceProps>`
    margin-bottom: 20px;
    ${space};
`;

export const DropdownLine = styled.div``;

export const InputGroup = styled.div`
    display: flex;
    position: relative;
    justify-content: space-between;
    width: 100%;
    min-width: 300px;
    font-family: ${theme.fonts.regular};
    font-size: 1.4rem;
    border-radius: 4px;

    ${IconWrapper} {
        position: absolute;
        top: 50%;
        left: ${theme.space[1]}px;
        line-height: 1;
        transform: translateY(-50%);
    }

    @media ${getBreakpoint("up", "lg")} {
        width: auto;
    }
    input {
        font-family: ${theme.fonts.book};
        font-size: 1.8rem;
        color: ${theme.colors.midnight};
        &::placeholder {
            font-family: ${theme.fonts.regular};
            font-size: 1.4rem;
            letter-spacing: 0.2rem;
            text-transform: uppercase;
            color: ${theme.colors.platinumDark};
        }
    }

    html[dir="rtl"] & {
        ${IconWrapper} {
            left: auto;
            right: ${theme.space[1]}px;
        }
    }
`;

export const InputGroupPrepend = styled.input`
    width: 100%;
    padding: 20px 20px 20px 50px;
    font-size: 1.4rem;
    color: ${theme.colors.midnight};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.platinumMedium};
    border-radius: 0;
    &:focus {
        border-color: ${theme.colors.midnight};
    }
`;

export const ResetButton = styled.button`
    display: flex;
    position: absolute;
    top: 50%;
    right: ${theme.space[2]}px;
    align-items: center;
    justify-content: center;
    background-color: transparent;
    border: 0;
    transform: translateY(-50%);
    ${Icon} {
        position: relative;
        left: 4px;
        &::before {
            font-size: 1.8rem;
        }
    }

    html[dir="rtl"] & {
        left: ${theme.space[2]}px;
        right: auto;
        ${Icon} {
            left: auto;
            right: 4px;
        }
    }
`;
